import { GET_GAME_CONFIGURATION_START, GET_GAME_CONFIGURATION_SUCCESS, RESET_STORE } from "./types";

const initialState = {
  attributes: [],
  device: "",
  integrator: {
    name: "",
  },
  loading: false,
  status: "",
  attributeCollection: {},
};

export default (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
  case GET_GAME_CONFIGURATION_START:
    return {
      ...state,
      loading: true,
    };
  case GET_GAME_CONFIGURATION_SUCCESS:
    return {
      ...payload.gameConfiguration,
      loading: false,
    };

  case RESET_STORE:
    return initialState;
  default:
    return state;
  }
};
